export const EVALUATION_PERIODS = {
  ANUAL: 'anual',
  BIANNUAL: 'semestral',
  QUARTERLY: 'trimestral',
  FOUR_MONTHLY: 'cuatrimestral',
  BIMONTHLY: 'bimensual',
};

export const EVALUATION_PERIODS_TYPES = [
  {
    name: EVALUATION_PERIODS.QUARTERLY,
    periods: [
      { name: 'Quarter 1', id: 't01' },
      { name: 'Quarter 2', id: 't02' },
      { name: 'Quarter 3', id: 't03' },
    ],
  },
  {
    name: EVALUATION_PERIODS.BIMONTHLY,
    periods: [
      { name: 'Bimester 1', id: 'b01' },
      { name: 'Bimester 2', id: 'b02' },
      { name: 'Bimester 3', id: 'b03' },
      { name: 'Bimester 4', id: 'b04' },
    ],
  },
  {
    name: EVALUATION_PERIODS.BIANNUAL,
    periods: [
      { name: 'Semester 1', id: 's01' },
      { name: 'Semester 2', id: 's02' },
    ],
  },
  { name: EVALUATION_PERIODS.ANUAL, periods: [{ name: 'School year', id: 'annual' }] },
];
